import { useShouldShowSmsNotificationsPrompt } from '../../billing/hooks/useShouldShowSmsNotificationsPrompt';
import { SmsNotificationsPrompt } from '../../billing/components/SmsNotificationsPrompt';
import React from 'react';
import { ReleasePrompt } from './ReleasePrompt';
import { ENV_E2E, readCommonConfig } from '../../commons/config';
import { useShouldShowPushNotificationPrompt } from '../../push-notifications/hooks/useShouldShowPushNotificationPrompt';
import { PushNotificationsModal } from '../../push-notifications/components/PushNotificationsModal';
import { PushNotificationsDeniedModal } from '../../push-notifications/components/PushNotificationsDeniedModal';

export const OnStartModalPrompt = () => {
  const showReleasePromptOnStart = readCommonConfig().env !== ENV_E2E;
  const { markReminded: markSmsNotificationsReminded } = useShouldShowSmsNotificationsPrompt();
  const shouldShowPushNotificationResult = useShouldShowPushNotificationPrompt();

  if (!!markSmsNotificationsReminded) {
    return <SmsNotificationsPrompt onClose={markSmsNotificationsReminded} />;
  }

  if (!!shouldShowPushNotificationResult) {
    const { markReminded: markPushNotificationsReminded, promptType } =
      shouldShowPushNotificationResult;
    return promptType === 'initial' ? (
      <PushNotificationsModal onClose={markPushNotificationsReminded} />
    ) : (
      <PushNotificationsDeniedModal onClose={markPushNotificationsReminded} />
    );
  }
  return showReleasePromptOnStart ? <ReleasePrompt /> : null;
};
